import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import './utils2.js';
import './ComponentError.js';
import './Checkout.js';
import './Pagination.js';
import './Payment.js';
import './Refund.js';
import { E as EntityDocumentType } from './Document.js';
import { d as defineCustomElement$3 } from './custom-popper2.js';
import { d as defineCustomElement$2 } from './form-control-file2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const BankAccountDocumentFormInputs = /*@__PURE__*/ proxyCustomElement(class BankAccountDocumentFormInputs extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
    }
    render() {
        return (h("div", { key: 'a3ff8b1ff23923beb847e66d6c56a39de9a86434', class: "row gy-3" }, h("div", { key: '86f9ba3a8f0f87f7fa67ba0fcf1d7c04f67e9bc5', class: "col-12" }, h("form-control-file", { key: '9cc2bc21414c8e3f4b25ac47b76340a4ce569c42', name: "voided_check", label: "Voided Check", documentType: EntityDocumentType.voidedCheck, inputHandler: this.inputHandler, onFileSelected: this.storeFiles, errorText: this.errors["voided_check"], multiple: true })), h("div", { key: 'bee72d6c63514cdbd3200910d3a53b045c60d05d', class: "col-12" }, h("form-control-file", { key: '80a79f352d078cd210768b4060cad7014b1060c5', name: "bank_statement", label: "Bank Statement", documentType: EntityDocumentType.bankStatement, inputHandler: this.inputHandler, onFileSelected: this.storeFiles, errorText: this.errors["bank_statement"], multiple: true }))));
    }
}, [0, "bank-account-document-form-inputs", {
        "inputHandler": [16, "input-handler"],
        "errors": [8],
        "storeFiles": [16, "store-files"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bank-account-document-form-inputs", "custom-popper", "form-control-file", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "bank-account-document-form-inputs":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BankAccountDocumentFormInputs);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-file":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { BankAccountDocumentFormInputs as B, defineCustomElement as d };
